import { DateTime } from 'luxon';
import { TimeZone } from '../types';

//Format date for visual display
const formatDate = (inputDate: DateTime, timeZone: TimeZone) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  return `${inputDate.toLocaleString(options)} ${timeZone.bclId}`;
};

export default formatDate;
